import { render } from "./TeamMemberData.vue?vue&type=template&id=4955c214"
import script from "./TeamMemberData.vue?vue&type=script&lang=js"
export * from "./TeamMemberData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__